module.exports = __webpack_public_path__ + "img/pricing-banner-mobile.94f29bcb.png";